import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination, EffectFade } from 'swiper/modules';

const blocks = document.querySelectorAll('.block-tab-featured');
const swiperInstances = [];

const initializeSliders = () => {
	if (swiperInstances.length > 0) {
		swiperInstances.forEach((swiperInstance) => {
			swiperInstance.update();
		});

		return;
	}

	blocks.forEach((block, index) => {
		const slider = block.querySelector('.swiper');
		const slides = block.querySelectorAll('.swiper-slide');

		if (!slider || 0 === slides.length) {
			return;
		}

		block.classList.add(`block-tab-featured--${index}`);

		const setProgress = (swiper) => {
			const progressPercentage =
				(swiper.activeIndex + 1) / swiper.slides.length;
			block.style.setProperty(
				'--swiper-progress',
				`${progressPercentage}`
			);
		};

		const settings = {
			loop: false,
			grabCursor: true,
			spaceBetween: 0,
			slidesPerView: 1,
			autoHeight: true,
			modules: [A11y, Navigation, Pagination, EffectFade],
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: `.block-tab-featured--${index} .swiper-button-prev`,
				nextEl: `.block-tab-featured--${index} .swiper-button-next`,
			},
			pagination: {
				el: `.block-tab-featured--${index} .swiper-pagination`,
				clickable: true,
				renderBullet(i, className) {
					const label =
						slides[i]?.dataset?.tabLabel ??
						(i + 1).toString().padStart(2, '0');
					return `<span class="${className}">${label}</span>`;
				},
			},
			on: {
				init(swiper) {
					setProgress(swiper);
				},
				slideChange(swiper) {
					setProgress(swiper);
				},
			},
			breakpoints: {
				768: {
					autoHeight: false,
				},
			},
		};

		swiperInstances.push(new Swiper(slider, settings));
	});
};

initializeSliders();

window.addEventListener('propel-viewport-changed-md', initializeSliders);
window.addEventListener('propel-viewport-changed-lg', initializeSliders);
